declare let M: any

export class Sidenav{

    public static init(){
        
        let elem = document.getElementsByClassName('sidenav');
        var close = document.getElementById('close-sidenav');
        var menuitems = document.getElementById('slide-out').getElementsByTagName('li')

        let options = {

        }

        for(let i = 0; i < elem.length; i++){
            var instance = M.Sidenav.init(elem.item(i), options);
        }

        close.addEventListener('click', function(){
            instance.close();
        })

        for(let i = 0; i < menuitems.length; i++){
            menuitems.item(i).addEventListener('click', function(){
                instance.close();
            })
        }
    }

}